import React from "react";

import Polygon from "../../../images/pattern/Polygon.png";
import RectangleBorderRight from "../../../images/pattern/RectangleBorderRight.png";
import RectangleBorderLeft from "../../../images/pattern/RectangleBorderLeft.png";
import RectangleLightRed from "../../../images/pattern/RectangleLightRed.png";

import { FormattedMessage } from "react-intl";

import classes from "./Layout.module.css";

const Layout = ({ titleId, subtitleId, children }) => {
  return (
    <>
      <div className={classes["main-container"]}>
        <img
          src={Polygon}
          alt="background pattern"
          className={classes.polygon}
        />
        <img
          src={RectangleBorderLeft}
          alt="background pattern"
          className={classes["rectangle-border-left"]}
        />
        <img
          src={RectangleBorderRight}
          alt="background pattern"
          className={classes["rectangle-border-right"]}
        />
        <img
          src={RectangleLightRed}
          alt="background pattern"
          className={classes["rectangle-light-red"]}
        />
        <section className={classes["title-section"]}>
          <div className={classes["title-container"]}>
            <h1 className={classes["title"]}>
              <FormattedMessage id={titleId} />
            </h1>
            <p className={classes["subtitle"]}>
              <FormattedMessage id={subtitleId} />
            </p>
          </div>
        </section>
        <section className={classes["contents-section"]}>
          <div className={classes["children-container"]}>{children}</div>
        </section>
      </div>
    </>
  );
};

export default Layout;
